import { render, staticRenderFns } from "./Textarea.vue?vue&type=template&id=081fd4cc&scoped=true"
import script from "./Textarea.vue?vue&type=script&lang=js"
export * from "./Textarea.vue?vue&type=script&lang=js"
import style0 from "./Textarea.vue?vue&type=style&index=0&id=081fd4cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fd4cc",
  null
  
)

export default component.exports